import { ELECTRICITY_SYSTEM_TYPE } from "@app/models/commissioning-mapped-data.interface";

// TODO: Remove when onelint 0.6.0 is used.
// eslint-disable-next-line @typescript-eslint/naming-convention
enum StaticTestId {
  SYSTEM_HEADING = "commissioning-electricity-systems-heading",
  METER_CHANGES = "meterChanges",
  NO_METER_CHANGES = "no-meter-changes",
  SYSTEM_TYPE_OTHER = "systemTypeOTHER",
  NOTES_OTHER = "notesOTHER",
}

export type SystemSelectionId =
  | "system-selection-card-pv"
  | "system-selection-card-storage"
  | "system-selection-card-charging-device"
  | "system-selection-card-heat-pump"
  | "system-selection-card-other";

const DYNAMIC_TEST_ID_SYSTEM_SELECTION: Record<
  ELECTRICITY_SYSTEM_TYPE,
  SystemSelectionId
> = {
  [ELECTRICITY_SYSTEM_TYPE.PV]: "system-selection-card-pv",
  [ELECTRICITY_SYSTEM_TYPE.STORAGE]: "system-selection-card-storage",
  [ELECTRICITY_SYSTEM_TYPE.CHARGING_DEVICE]:
    "system-selection-card-charging-device",
  [ELECTRICITY_SYSTEM_TYPE.HEAT_PUMP]: "system-selection-card-heat-pump",
  [ELECTRICITY_SYSTEM_TYPE.OTHER]: "system-selection-card-other",
} as const;

export type FormPowerTestId =
  | "systemPowerPV"
  | "systemPowerSTORAGE"
  | "systemPowerCHARGING_DEVICE"
  | "systemPowerHEAT_PUMP"
  | "systemPowerOTHER";

const DYNAMIC_TEST_ID_SYSTEM_POWER: Record<
  ELECTRICITY_SYSTEM_TYPE,
  FormPowerTestId
> = {
  [ELECTRICITY_SYSTEM_TYPE.PV]: "systemPowerPV",
  [ELECTRICITY_SYSTEM_TYPE.STORAGE]: "systemPowerSTORAGE",
  [ELECTRICITY_SYSTEM_TYPE.CHARGING_DEVICE]: "systemPowerCHARGING_DEVICE",
  [ELECTRICITY_SYSTEM_TYPE.HEAT_PUMP]: "systemPowerHEAT_PUMP",
  [ELECTRICITY_SYSTEM_TYPE.OTHER]: "systemPowerOTHER",
} as const;

export type FormCountTestId =
  | "systemCountPV"
  | "systemCountSTORAGE"
  | "systemCountCHARGING_DEVICE"
  | "systemCountHEAT_PUMP"
  | "systemCountOTHER";

const DYNAMIC_TEST_ID_SYSTEM_COUNT_BY_SYSTEM_TYPE: Record<
  ELECTRICITY_SYSTEM_TYPE,
  FormCountTestId
> = {
  [ELECTRICITY_SYSTEM_TYPE.PV]: "systemCountPV",
  [ELECTRICITY_SYSTEM_TYPE.STORAGE]: "systemCountSTORAGE",
  [ELECTRICITY_SYSTEM_TYPE.CHARGING_DEVICE]: "systemCountCHARGING_DEVICE",
  [ELECTRICITY_SYSTEM_TYPE.HEAT_PUMP]: "systemCountHEAT_PUMP",
  [ELECTRICITY_SYSTEM_TYPE.OTHER]: "systemCountOTHER",
} as const;

export const TEST_ID = {
  statics: StaticTestId,
  dynamic: {
    systemSelection: DYNAMIC_TEST_ID_SYSTEM_SELECTION,
    systemPower: DYNAMIC_TEST_ID_SYSTEM_POWER,
    systemCount: DYNAMIC_TEST_ID_SYSTEM_COUNT_BY_SYSTEM_TYPE,
  },
} as const;
